export class ChamadaModel {
    sqlCommand?: string
    empresa?: string
    rpt?: string
    link?: string
    nome_arquivo?: string
    cod_cliente?: number

    cod_chamada?: number;
    id_tecnico?: string;
    id_elevador?: string;
    num_ate?: number;
    grupo?: string;
    data?: Date;
    cliente?: string;
    visita?: string;
    resolvido?: string;
    hora?: string;
    tipo_contrato?: string;
    endereco?: string;
    bairro?: string;
    cep?: string;
    reclamante?: string;
    elevador?: string;
    data_mec_antiga?: Date;
    data_mec?: string;
    hora_mec?: string;
    cod_mec?: number;
    mec?: string;
    inicio?: string;
    fechamento?: string;
    tempo_espera?: string;
    tempo_atendimento?: string;
    numdef?: string;
    defeito?: string;
    rsp?: string;
    aviso?: string;
    entrada?: string;
    equipamento?: string;
    pecas?: string;
    defeitos?: string;
    saida?: string;
    solucoes?: string;
    setorxxx?: string;
    obs?: string;
    sms?: boolean;
    tratamento?: string;
    urgencia_atendimento?: string;
    tipo_cliente?: string;
    equipamento_automacao?: string;
    tipo_pendencia?: string;
    cod_orcamento?: number;
    numsol?: string;
    solucao?: string;
    obs_tele?: string;
    gastos?: number;
    texto_pend?: string;
    num_orca?: string;
    pend?: boolean;
    num_ate_pen?: number;
    situacao?: string;
    id_tipo_os?: string;
    id_atendente?: string;

    filtro_data_inicial?:Date
    filtro_data_final?:Date

    data_inicial?:Date
    data_final?:Date

    filtro?: string

    coligada?: string

}
